import * as Accordion from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";
import { SectionHead, Em } from "@/components/Reveal";

const faqs = [
  { q: "WHAT EXACTLY IS WILD WOMAN MILLIONS?", a: "A digital vision experience by Dasha Love built on one method: Vision → Blueprint → Quantum Habits → Capacity → Currency. You clarify the life you actually want, design the blueprint for it, install 7 daily rituals, and expand your capacity to hold more of it." },
  { q: "HOW DOES THE EXPERIENCE WORK?", a: "You get instant digital access after checkout and move through it at your own pace — video sessions, guided meditations, hypnosis, breathwork, the books, and the bonus programs." },
  { q: "WHAT ARE THE 7 QUANTUM HABITS™?", a: "The daily ritual practice inside the experience: the 7 daily rituals, accountability, inner child meditation, rituals hypnosis, pattern disruption meditation, the unconditional-love rite of passage, and dance rituals." },
  { q: "HOW LONG DOES IT TAKE?", a: "It’s self-paced. You’ll be guided to choose a 30-, 60-, or 90-day vision for your current chapter — you don’t have to solve your entire future before your next step." },
  { q: "IS THIS ABOUT BUSINESS OR MY WHOLE LIFE?", a: "Your whole life. It’s powerful for entrepreneurs and creators, but the work spans business, love, family, freedom, health, creativity, and pleasure." },
  { q: "IS THIS A MANIFESTATION COURSE?", a: "No. This is a practiced method: see the vision, choose it, blueprint it, embody it daily, and expand your capacity to hold it. Desire becomes decision becomes embodiment." },
  { q: "WHAT’S INCLUDED?", a: "The complete Wild Woman Millions experience, your Vision Blueprint work, the 7 Quantum Habits™ rituals, three digital books, both bonus programs (7 Daily Rituals and The Blueprint), guided meditations, hypnosis, breathwork, and Skool access. All digital." },
  { q: "DO I GET INSTANT ACCESS?", a: "Yes. Access instructions are delivered digitally right after checkout. No physical products are shipped." },
  { q: "HOW MUCH IS IT?", a: "$27 — one payment. Individual experiences and results vary; no specific financial or business result is guaranteed." },
];

export const FaqSection = () => (
  <section data-testid="faq-section" className="mx-auto max-w-3xl px-5 py-20 sm:py-28">
    <SectionHead eyebrow="QUESTIONS, ANSWERED" center>
      BEFORE YOU <Em>ENTER.</Em>
    </SectionHead>

    <Accordion.Root type="single" collapsible data-testid="faq-accordion">
      {faqs.map((f, i) => (
        <Accordion.Item key={f.q} value={`faq-${i}`} className="border-b border-white/10">
          <Accordion.Header>
            <Accordion.Trigger
              data-testid={`faq-trigger-${i + 1}`}
              className="group flex w-full items-center gap-4 py-5 text-left"
            >
              <span className="font-mono text-xs text-lime">0{i + 1}</span>
              <span className="flex-1 text-sm font-extrabold tracking-wide text-cream sm:text-base">{f.q}</span>
              <Plus className="h-5 w-5 shrink-0 text-lime transition-transform duration-300 group-data-[state=open]:rotate-45" />
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
            <p data-testid={`faq-answer-${i + 1}`} className="pb-6 pl-9 pr-4 text-sm leading-relaxed text-cream/65">
              {f.a}
            </p>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  </section>
);
